import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appCustomAngularEditor]'
})
export class CustomAngularEditorDirective implements AfterViewInit {

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit() {
    this.customEditor();
  }

  customEditor() {
    const toolbar = this.el.nativeElement.querySelector('.angular-editor-toolbar');
    if (toolbar) {
      this.renderer.setStyle(toolbar, 'background-color', 'var(--bg-white, #FFF)');
      this.renderer.setStyle(toolbar, 'border', '0');
    }
  }
}
